import axiosInstance from "./axiosInstance";

export interface VenueTypeConfigFilters {
  pageNo?: number;
  pageSize?: number;
  searchTerm?: string;
  // status?: string;
  statusFilter?: string;
  typeFilter?: string;
}

/////
export interface ApproveVenueAllocationRequest {
  tourCategory: number;
  venueRequests: VenueRequest[];
}

export interface VenueRequest {
  venueId: number;
  propertyId: number;
  roomRequests: RoomRequestAllocation[];
}

export interface RoomRequestAllocation {
  roomId: number;
  roomAllocated: number;
}

export interface TourChatSubmissionPayload {
  tourPublicId: string;
  message: string;
  isInternal: boolean;
}

export interface TourChat {
  isAdmin:boolean;
  publicId: string;
  senderName: string;
  message: string;
  isInternal: boolean;
  createdAt: string;
  createdOn: string
}

export interface RecommendDatesPayload {
  startDate: string;
  endDate: string;
  reason: string;
  type: number;
}
////


// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getVenueApprovalList = async (
  filters: VenueTypeConfigFilters = {},
) => {
  try {
    const response = await axiosInstance.get("/tours/venue-approval/list", {
      params: {
        pageNo: filters.pageNo ?? 0,
        pageSize: filters.pageSize ?? 20,
        searchText: filters.searchTerm || undefined,
        status: filters.statusFilter || undefined,
        TourType: filters?.typeFilter || undefined
      },
      headers: {
        ...getAuthHeader(),
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};


////
export const getVenueApprovalDetailsPublicId = async (publicId: string) => {
  try {
    const response = await axiosInstance.get(
      `/tours/venue-approval/${publicId}/properties`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const approveVenueAllocation = async (
  publicId: string | number,
  updatedBy: number,
  payload: ApproveVenueAllocationRequest,
) => {
  const response = await axiosInstance.post(
    `/tours/venue-approval/${publicId}`,
    payload,
    {
      headers: {
        ...getAuthHeader(),
      },
      params: {
        updatedBy,
      },
    },
  );

  return response.data;
};
////

// CALENDER FUNCTIONS
// export const getRecommendedDates = async (tourId: string) => {
//   const response = await axiosInstance.get(
//     "/tours/venue-availability/recommended-dates",
//     {
//       headers: {
//         ...getAuthHeader(),
//       },
//       params: {
//         TourId: tourId,
//       },
//     }
//   );

//   return response.data;
// };


export const getFaizRecommendedDates = async (
  toutPublicId: string,
  monthYear: string
) => {
  const response = await axiosInstance.get(
    `/tours/venue-availability/${toutPublicId}/faiz-recommended-dates`,
    {
      params: {
        monthYear,
      },
      headers: {
        ...getAuthHeader(),
      },
    }
  );

  return response.data;
};


export const getHotelRecommendedDates = async (
  toutPublicId: string,
  monthYear: string
) => {
  const response = await axiosInstance.get(
    `/tours/venue-availability/${toutPublicId}/applicant-staying-dates`,
    {
      params: {
        monthYear,
      },
      headers: {
        ...getAuthHeader(),
      },
    }
  );

  return response.data;
};


export const sendRecommendDates = async (
  tourPublicId: string,
  payload: RecommendDatesPayload
) => {
  const response = await axiosInstance.post(
    `/tours/${tourPublicId}/venue-availability/send-recommend-dates`,
    payload,
    {
      headers: {
        ...getAuthHeader(),
      },
    }
  );

  return response.data;
};
//CALENDER FUNDTION


// TOUR CHAT START
export const getTourChats = async (tourPublicId: string) => {
  const response = await axiosInstance.get(
    `/tour-conversation/${tourPublicId}`,
    {
      headers: {
        ...getAuthHeader(),
      },
      // params: {
      //   tourPublicId: tourPublicId,
      // },
    }
  );
  return response.data;
};


export const tourChatsubmittion = async (
  payload: TourChatSubmissionPayload,
) => {
  const response = await axiosInstance.post(
    "/tour-conversation/send",
    payload,
    {
      headers: {
        ...getAuthHeader(),
      },
    }
  );

  return response.data;
};
// TOUR CHAT END
